import type { AppEntryReturnDestination } from '@core/entities/AppEntryContext';

const storageKey = 'inav.app-entry.original-origin';
const allowedDestinationIds: ReadonlySet<string> = new Set(['homepage', 'messages', 'profile']);
const allowedAppPages: ReadonlySet<string> = new Set(['homePage', 'messages', 'account']);

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function isOriginalOrigin(value: unknown): value is AppEntryReturnDestination {
  return isRecord(value)
    && typeof value.id === 'string'
    && allowedDestinationIds.has(value.id)
    && typeof value.label === 'string'
    && typeof value.appPage === 'string'
    && allowedAppPages.has(value.appPage)
    && typeof value.browserUri === 'string';
}

export class OriginalOriginStore {
  public get(): AppEntryReturnDestination | undefined {
    const storedValue = globalThis.sessionStorage.getItem(storageKey);
    if (!storedValue) {
      return undefined;
    }

    try {
      const parsed = JSON.parse(storedValue) as unknown;
      return isOriginalOrigin(parsed) ? parsed : undefined;
    } catch {
      return undefined;
    }
  }

  public remember(destinations: readonly AppEntryReturnDestination[]): void {
    const originalOrigin = destinations[0];
    if (!originalOrigin) {
      globalThis.sessionStorage.removeItem(storageKey);
      return;
    }

    globalThis.sessionStorage.setItem(storageKey, JSON.stringify(originalOrigin));
  }
}
